import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/icon_left.png';
import _imports_1 from '@/assets/img/calendar/question_picture.png';
import _imports_2 from '@/assets/icon/collect.png';
import _imports_3 from '@/assets/icon/collect_light.png';
import _imports_4 from '@/assets/icon/details_share.png';
import _imports_5 from '@/assets/icon/bar_ic_arr.png';
import _imports_6 from '@/assets/img/calendar/down-app.png';
const _withScopeId = n => (_pushScopeId("data-v-f215149c"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onClick"];
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", { src: _imports_0 }, null, -1));
const _hoisted_3 = [
    _hoisted_2
];
const _hoisted_4 = { class: "title" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    class: "shareBtn icon-share-black",
    "data-v-30b11c18": ""
}, null, -1));
const _hoisted_7 = [
    _hoisted_6
];
const _hoisted_8 = { class: "detailDate" };
const _hoisted_9 = { class: "dateLeft itemCenter" };
const _hoisted_10 = { class: "dateDay" };
const _hoisted_11 = { style: { "margin-top": "14px" } };
const _hoisted_12 = { class: "dateMonth" };
const _hoisted_13 = { class: "detailWeek" };
const _hoisted_14 = { class: "dateRight" };
const _hoisted_15 = { class: "knowledgeBox" };
const _hoisted_16 = { class: "knowledgeContent" };
const _hoisted_17 = { class: "contentTitle itemCenter" };
const _hoisted_18 = ["src"];
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "knowledgePoints" }, "KNOWLEDGE POINTS", -1));
const _hoisted_20 = ["innerHTML"];
const _hoisted_21 = { class: "knowledgeList" };
const _hoisted_22 = ["onClick", "innerHTML"];
const _hoisted_23 = ["innerHTML"];
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "listBottom" }, null, -1));
const _hoisted_25 = { class: "videoBox" };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "videoTip",
    src: _imports_1,
    alt: ""
}, null, -1));
const _hoisted_27 = { class: "videoBorder" };
const _hoisted_28 = { class: "videoInfo itemCenter" };
const _hoisted_29 = { class: "lecturerInfo" };
const _hoisted_30 = { class: "lecturerName" };
const _hoisted_31 = {
    key: 0,
    class: "collectIcon",
    src: _imports_2,
    alt: ""
};
const _hoisted_32 = {
    key: 1,
    class: "collectIcon",
    src: _imports_3,
    alt: ""
};
const _hoisted_33 = {
    key: 2,
    class: "bookmarkNum"
};
const _hoisted_34 = { key: 3 };
const _hoisted_35 = ["onClick"];
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "collectIcon",
    src: _imports_4,
    alt: ""
}, null, -1));
const _hoisted_37 = /*#__PURE__*/ _createTextVNode(" 分享 ");
const _hoisted_38 = [
    _hoisted_36,
    _hoisted_37
];
const _hoisted_39 = { class: "hospitalName" };
const _hoisted_40 = ["onClick"];
const _hoisted_41 = { class: "courseName" };
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_5,
    alt: ""
}, null, -1));
const _hoisted_43 = {
    key: 0,
    class: "appTipWrapper"
};
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "camp-fix-l itemCenter" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_6,
        alt: ""
    }),
    /*#__PURE__*/ _createElementVNode("div", { class: "camp-fix-r" }, [
        /*#__PURE__*/ _createElementVNode("p", null, "好医术APP"),
        /*#__PURE__*/ _createElementVNode("p", null, "更多精彩内容，请体验好医术APP")
    ])
], -1));
const _hoisted_45 = { class: "fixed-dialog" };
const _hoisted_46 = { class: "content" };
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "提示", -1));
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createTextVNode(" 每日更新一个知识点 "),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode(" 分享后即可观看 ")
], -1));
import { getDetail, getCalendarBookmark } from '@api/canlendar';
import { hostPath } from '@utils/basePath';
import VideoPlayer from '@/components/common/VideoPlayer.vue';
import { isLogin, userLogin, appPort, appFullScreen, closeWebView, calendarDetailAlert, getUserId, jumpModuleApp, imagePreview, weixinShare, recommendGIO } from '@/widget/index';
import { Toast, ImagePreview } from 'vant';
import { useRoute } from 'vue-router';
import courseRecommend from '@/components/course/courseRecommend.vue';
import { nextTick, onBeforeMount, onMounted, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const route = useRoute();
        const userId = getUserId();
        const list = ref({});
        const isApp = ref(appPort());
        const calendarId = Number(route.params.id || '');
        let shareInfo = ref({});
        let now = new Date();
        let nowMonth = now.getMonth() + 1;
        const colorList = ['#F4FBF1', '#F1FBFB', '#FAF8F4', '#F4FBFC'];
        let type = ref(0);
        const showDialog = ref(false);
        const videoPlayer = ref();
        /* 显示分享弹框 */
        const isShow = () => {
            showDialog.value = true;
        };
        /* 返回 */
        const backFn = () => {
            closeWebView();
        };
        /* 分享 */
        const shareFn = () => {
            if (isApp.value) {
                calendarDetailAlert(list.value);
                showDialog.value = false;
            }
            else {
                Toast('点击右上角进行分享');
            }
        };
        const images = [];
        const content = ref('');
        const loaded = ref(false);
        /* 获取日历详情 */
        const detailData = () => {
            getDetail(calendarId, {
                userId
            }).then(res => {
                loaded.value = true;
                if (res.code === 200) {
                    list.value = res.data;
                    let description = res.data.description || '';
                    content.value = description.replace(/(\n\n|\n)/g, '<br />');
                    //  微信二次分享
                    if (!isApp.value) {
                        const { albumName, lecturerName, hospitalName, QRCodeUrl } = list.value || {};
                        shareInfo.value = {
                            title: albumName,
                            desc: lecturerName + '|' + hospitalName,
                            url: QRCodeUrl,
                            image: 'https://img-a.haoyishu.com/images/share/hys_logo.png'
                        };
                        list.value.description = content.value;
                        weixinShare(shareInfo.value);
                    }
                    list.value.description = content.value;
                    nextTick(() => {
                        var dom = document.querySelector('.knowledgeList img');
                        images.push(dom?.getAttribute('src') || '');
                    });
                }
            });
        };
        /* 收藏 */
        const goBookmark = (status) => {
            if (!isLogin) {
                userLogin();
            }
            else {
                getCalendarBookmark({
                    calendarId,
                    userId,
                    type: status ? 'off' : 'on'
                }).then(res => {
                    if (res.code === 200) {
                        if (status) {
                            Toast('已取消收藏');
                        }
                        else {
                            Toast('收藏成功');
                        }
                        detailData();
                    }
                });
            }
        };
        /* 查看课程详情 */
        const openDetail = () => {
            let { courseId, moduleType, videoId } = list.value;
            if (appPort()) {
                jumpModuleApp({
                    typeId: 'open_detail',
                    dataId: courseId
                });
            }
            else {
                let url = '';
                let type = moduleType.toLocaleLowerCase(); // vip masterClass pbl case open
                if (/^(masterClass|pbl)$/.test(moduleType)) {
                    url = `/international/detail?id=${courseId}&${videoId}`;
                }
                else if (moduleType == 'vip') {
                    url = `/member/detail?id=${courseId}&videoId=${videoId}`;
                }
                else {
                    url = `/${type}/detail?id=${courseId}&videoId=${videoId}`;
                }
                location.assign(hostPath + url);
            }
        };
        /* 打开app */
        const downAPP = () => {
            location.href = `https://datayi.cn/bLbjaaidWmmO`;
        };
        if (isApp.value) {
            appFullScreen();
        }
        const previewImg = () => {
            if (!images.length) {
                return;
            }
            if (isApp.value) {
                imagePreview({ typeId: 'image_preview', images: images, posIndex: 0 });
            }
            else {
                ImagePreview({
                    images: images,
                    closeable: true,
                    startPosition: 0
                });
            }
        };
        const scrollH = ref(0);
        const scrollFn = () => {
            scrollH.value = document.documentElement.scrollTop || document.body.scrollTop;
        };
        const domH = ref(70);
        const clickRecommend = data => {
            // 查看推荐
            return new Promise(resolve => {
                let { depName, albumName, albumId } = list.value;
                recommendGIO({
                    departmentType: depName,
                    recommendedCarrier: 'calendarCase',
                    course_ID: albumId + '',
                    course_name: albumName,
                    moduleType: 'knowledge',
                    ...data
                }).then(() => {
                    resolve(true);
                });
            });
        };
        onMounted(() => {
            let dom = document.querySelector('.headerWrapper');
            if (dom) {
                domH.value = dom.offsetHeight;
            }
            window.addEventListener('scroll', scrollFn, false);
            // 根据季节改变背景色
            type.value = nowMonth < 10 ? Math.floor(nowMonth / 4) : 3;
            detailData();
        });
        onBeforeMount(() => {
            window.removeEventListener('scroll', scrollFn, false);
        });
        window.getViewBarHeight = (h) => {
            console.log(h, 'h');
        };
        window.updateCanlender = () => {
            detailData();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "detailPage",
                style: _normalizeStyle({ backgroundColor: colorList[_unref(type)] })
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(["detailTop", { inApp: isApp.value }]),
                    style: _normalizeStyle({
                        backgroundImage: 'url(' + (list.value.topUrl ? list.value.topUrl : '') + ')',
                        backgroundSize: '100% 100%',
                        backgroundRepeat: 'no-repeat'
                    })
                }, [
                    (isApp.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["header itemCenter headerWrapper", { whiteBg: scrollH.value >= domH.value }])
                        }, [
                            _createElementVNode("div", {
                                class: "back",
                                onClick: _withModifiers(backFn, ["stop"])
                            }, _hoisted_3, 8, _hoisted_1),
                            _createElementVNode("div", _hoisted_4, _toDisplayString(list.value?.title), 1),
                            _createElementVNode("div", {
                                class: "titleShare",
                                onClick: _withModifiers(shareFn, ["stop"])
                            }, _hoisted_7, 8, _hoisted_5)
                        ], 2))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, _toDisplayString(list.value?.today), 1),
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("span", _hoisted_12, _toDisplayString(list.value?.todayEn), 1),
                                _createElementVNode("div", _hoisted_13, _toDisplayString(list.value?.week), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(list.value?.cyclicalYMD), 1)
                    ])
                ], 6),
                _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("img", {
                                class: "departmentIcon",
                                src: list.value?.titleUrl,
                                alt: ""
                            }, null, 8, _hoisted_18),
                            _hoisted_19
                        ]),
                        _createElementVNode("div", {
                            class: "knowledgeTitle",
                            innerHTML: list.value?.albumName
                        }, null, 8, _hoisted_20),
                        _createElementVNode("ul", _hoisted_21, [
                            (/<img\s/gi.test(list.value.description))
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 0,
                                    class: "imgBox",
                                    onClick: _withModifiers(previewImg, ["stop"]),
                                    innerHTML: list.value.description
                                }, null, 8, _hoisted_22))
                                : (_openBlock(), _createElementBlock("li", {
                                    key: 1,
                                    class: "listTitle",
                                    innerHTML: content.value
                                }, null, 8, _hoisted_23))
                        ]),
                        _hoisted_24
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("div", _hoisted_27, [
                            _createVNode(VideoPlayer, {
                                ref: (_value, _refs) => {
                                    _refs['videoPlayer'] = _value;
                                    videoPlayer.value = _value;
                                },
                                class: "playerBox",
                                videoId: list.value.videoMd5,
                                poster: list.value.albumImageUrl,
                                login: true,
                                permission: list.value.permission,
                                onIsShow: isShow,
                                calendar: true
                            }, null, 8, ["videoId", "poster", "permission"])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("span", _hoisted_30, _toDisplayString(list.value?.lecturerName), 1)
                            ]),
                            _createElementVNode("div", {
                                class: "videoCollect itemCenter",
                                onClick: _cache[0] || (_cache[0] = ($event) => (goBookmark(list.value?.bookmarkStatus)))
                            }, [
                                (!list.value?.bookmarkStatus)
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_31))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_32)),
                                (list.value?.bookmarkStatus)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(list.value?.bookmarkCount), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(list.value?.bookmarkCount !== '0' || Number(list.value?.bookmarkCount) > 0
                                        ? list.value?.bookmarkCount
                                        : '收藏'), 1))
                            ]),
                            _createElementVNode("div", {
                                class: "videoShare itemCenter",
                                onClick: _withModifiers(shareFn, ["stop"])
                            }, _hoisted_38, 8, _hoisted_35)
                        ]),
                        _createElementVNode("div", _hoisted_39, _toDisplayString(list.value?.hospitalName), 1),
                        _createElementVNode("div", {
                            class: "viewDetail itemCenter",
                            onClick: _withModifiers(openDetail, ["stop"])
                        }, [
                            _createElementVNode("div", _hoisted_41, "观看完整内容：" + _toDisplayString(list.value?.courseName), 1),
                            _hoisted_42
                        ], 8, _hoisted_40)
                    ])
                ]),
                _createVNode(courseRecommend, {
                    "module-type": 'calendar_knowledge',
                    courseId: _unref(calendarId) + '',
                    loaded: loaded.value,
                    onClickRecommend: clickRecommend
                }, null, 8, ["courseId", "loaded"]),
                (!isApp.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _createElementVNode("div", { class: "camp-fix itemCenter" }, [
                            _hoisted_44,
                            _createElementVNode("div", {
                                class: "camp-app",
                                onClick: downAPP
                            }, "打开APP")
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("i", {
                            class: "icon",
                            onClick: _cache[1] || (_cache[1] = ($event) => (showDialog.value = false))
                        }),
                        _hoisted_47,
                        _hoisted_48,
                        _createElementVNode("span", {
                            class: "cancel",
                            onClick: _cache[2] || (_cache[2] = ($event) => (showDialog.value = false))
                        }, "取消"),
                        _createElementVNode("span", {
                            class: "confirm",
                            onClick: shareFn
                        }, "确认分享")
                    ])
                ], 512), [
                    [_vShow, showDialog.value]
                ])
            ], 4));
        };
    }
});
